export default __webpack_public_path__ + "static/media/TL12.c7dc1415.mp3";